import { config } from 'src/env.js';
import { buildDefaultOptions } from './globalServices';
import { httpGet, httpPost, httpPut, httpDelete, buildURLQuery } from './httpServices';

const API_BASE_URI = `${config.apis.coreApi.URL}`;
const HOLIDAY_ENDPOINT_URL = '/holidays';
const HOLIDAY_TYPES_ENDPOINT_URL = '/holiday-types';

export const listHoliday = async (accessToken, params) => {
    const options = buildDefaultOptions(accessToken);

    const holidayURLQuery = {
        page: params?.page,
        size: params?.pageSize,
        sort: params?.sort,
        name: params?.name,
        dateFrom: params?.date,
        dateTo: params?.date
    }

    const queryString = buildURLQuery(holidayURLQuery);
    const URL = `${API_BASE_URI}${HOLIDAY_ENDPOINT_URL}?${queryString}`;

    let response;

    try {
        response = await httpGet(URL, options);
    }
    catch (error) {
        return error;
    }

    return response;
};

export const createHoliday = async (accessToken, data) => {
    const options = buildDefaultOptions(accessToken);
    const URL = `${API_BASE_URI}${HOLIDAY_ENDPOINT_URL}`;

    let response;

    try {
        response = await httpPost(URL, data, options);
    }
    catch (error) {
        return error;
    }

    return response;
};

export const deleteHoliday = async (accessToken, id) => {
    const options = buildDefaultOptions(accessToken);
    const URL = `${API_BASE_URI}${HOLIDAY_ENDPOINT_URL}/${id}`;

    let response;

    try {
        response = await httpDelete(URL, options);
    }
    catch (error) {
        return error?.response || error;
    }
    return response;
};

export const editHoliday = async (accessToken, params) => {

    const URL = `${API_BASE_URI}${HOLIDAY_ENDPOINT_URL}/${params?.id}`;
    const options = buildDefaultOptions(accessToken);

    let response;

    try {
        response = await httpPut(URL, params, options);
    }
    catch (error) {
        return error;
    }

    return response;
};

export const getHolidayTypeList = async (accessToken, params) => {
    const options = buildDefaultOptions(accessToken);

    const holidayURLQuery = {
        page: params?.page,
        size: params?.pageSize,
        sort: params?.sort,
    }

    const queryString = buildURLQuery(holidayURLQuery);
    const URL = `${API_BASE_URI}${HOLIDAY_TYPES_ENDPOINT_URL}?${queryString}`;

    let response;

    try {
        response = await httpGet(URL, options);
    }
    catch (error) {
        return error;
    }

    return response;
};

